<template>
  <div class="youkexianxiaxingweifenxi">
    <IconList :list="list" :marginBottom="0.3"/>
  </div>
</template>

<script>
import IconList from "@/components/Mycharts/IconList.vue";

export default {
  name: "YoukeXianxiaXingweiFenxi",
  components: {
    IconList
  },
  props: {
    data: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      list: [
        {
          listName: "出游时间",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon1.png")
        },
        {
          listName: "交通方式",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon2.png")
        },
        {
          listName: "消费潜力",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon3.png")
        },
        {
          listName: "隔夜情况",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon4.png")
        },
        {
          listName: "出游距离",
          listIcon: require("../../assets/youkexianxiaxingweifenxi/icon5.png")
        }
      ]
    };
  },
  mounted() {}
};
</script>

<style scoped lang="less"></style>
